import { ModelBase } from 'store/model-base';

export class CmsDeviceCancel extends ModelBase {
    public static storeName: string = 'cmsDeviceCancel';

    public canceled: CmsCanceledInfo;
    public accountPin: CmsAccountPin;
    public accountPinPortOut: CmsAccountPinLineLock;
    public portOutDialog: ResultDialog;
    public fccSimSwapPortOutPin: FccSimSwapPortOut;
    public success: CmsSuccessInfo;
}
